import numeral from "numeral";

export const postfixNumber = (num: number) =>
  num < 1000 ? num : numeral(num).format("0.0a");
